var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      width: "55%",
      display: "inline-block"
    }
  }, [_c("a-form-model", {
    ref: "ruleForm",
    staticClass: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("消息标题"),
      prop: "title"
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("消息标题"),
      allowClear: "",
      disabled: !_vm.isEdit
    },
    model: {
      value: _vm.form.title,
      callback: function ($$v) {
        _vm.$set(_vm.form, "title", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.title"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("消息内容"),
      prop: "fileContent"
    }
  }, [_c("quill-editor", {
    ref: "myTextEditor",
    staticStyle: {
      height: "540px"
    },
    attrs: {
      options: _vm.quillOption,
      placeholder: _vm.$t("请输入") + _vm.$t("消息内容"),
      disabled: !_vm.isEdit
    },
    model: {
      value: _vm.form.fileContent,
      callback: function ($$v) {
        _vm.$set(_vm.form, "fileContent", $$v);
      },
      expression: "form.fileContent"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("上传文件"),
      prop: "fileList"
    }
  }, [_c("a-upload", {
    attrs: {
      action: _vm.action,
      multiple: true,
      "file-list": _vm.form.fileList,
      "before-upload": _vm.beforeUpload,
      accept: ".doc,.docx,.xlsx,.xls,.mp4,.jpg,.pdf,.jpeg,.png",
      disabled: !_vm.isEdit,
      data: {
        module: "fileMessages"
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      change: e => _vm.handleChange(e),
      preview: _vm.previewFile
    }
  }, [_c("div", [_c("a-button", {
    staticStyle: {
      "padding-left": "0px"
    },
    attrs: {
      type: "link",
      block: "",
      disabled: !_vm.isEdit
    }
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _vm._v(_vm._s(_vm.$t("点击上传文件")))], 1)], 1)])], 1), _vm.attachmentVariable && _vm.attachmentVariable.length > 0 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("附件变量"),
      prop: "variable"
    }
  }, _vm._l(_vm.attachmentVariable, function (variableItem) {
    return _c("a-button", {
      key: variableItem.mark,
      staticClass: "marginR15",
      attrs: {
        type: variableItem.isCheck ? "primary" : "default"
      },
      on: {
        click: function ($event) {
          return _vm.changeCheck(variableItem);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(variableItem.name)) + " ")]);
  }), 1) : _vm._e()], 1), _c("preview-modal", {
    attrs: {
      visible: _vm.previewVisible,
      videoTypeList: ["mov", "mp4"],
      fileList: _vm.form.fileList,
      show: _vm.fileType,
      src: _vm.previewSrc,
      currentIndex: _vm.currentPreviewIndex
    },
    on: {
      cancel: _vm.cancelPre
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };